import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Container } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
const Termscondition = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js"; 
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      {/* home */}

      <div>
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
          <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b>-boost your SEO game&nbsp;&nbsp; <Button size="sm" variant="success">Know More</Button>
          </p>
        </div> */}
        <Nav />
      </div>
      {/* start */}
      <div className="container p-0">
        <div className="mt-md-5 mt-3">
          <div className="row  mx-md-0 mx-3  mt-sm-3">
            <div className="col-md-1 "></div>
            <div className="col m-0 p-0">
              <div className="container m-0 p-0">
                <h4 className="text-center ">Terms And Conditions</h4>
                <section className="mb-4">
                  <p style={{ fontSize: ".9rem" }}>
                    Please read these Terms and Conditions ("Terms", "Terms and
                    Conditions") carefully before using the (
                    <a
                      href="https://www.SeoBix.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.SeoBix.com
                    </a>
                    website (the "Service") operated by SeoBix ("us", "we", or
                    "our").
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    Your access to and use of the Service is conditioned upon
                    your acceptance of and compliance with these Terms. These
                    Terms apply to all visitors, users and others who wish to
                    access or use the Service.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    By accessing or using the Service you agree to be bound by
                    these Terms. If you disagree with any part of the terms,
                    then you do not have permission to access the Service.
                  </p>
                </section>
                <section className="mb-4">
                  <h5>USER AGREEMENT:</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    As a condition of use, you agree not to use the Service for
                    any purpose that is unlawful or prohibited by these Terms of
                    Service, or any other purpose not reasonably intended by
                    SeoBix
                  </p>
                  <h5>Users of SeoBix Services Agreement:</h5>
                  <ul>
                    <li style={{ fontSize: ".9rem" }}>
                      You will not use SeoBix to carry out unlawful, misleading,
                      malicious, or discriminatory actions.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      You will not take any action that could disable,
                      overburden, or impair the proper working of SeoBix.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      You will not collect users’ content or information, or
                      otherwise access SeoBix, using automated means (such as
                      crawelers, robots, spiders, or scrapers) without our
                      permission.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      You will not upload viruses or other documents with
                      malicious purpose.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      You will not solicit login information or access an
                      account belonging to someone else.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      You will not upload content that legally belongs to
                      another person or entity.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      You will not facilitate or encourage any violations of
                      this Statement.
                    </li>
                  </ul>
                </section>
                <section className="mb-4">
                  <h5> Introduction</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    Our SEO services platform is designed to help your website
                    climb search engine rankings, attract more visitors, and
                    achieve measurable business goals. We begin by conducting
                    in-depth keywords research and competitor analysis to
                    identify growth opportunities. Our process includes on-page
                    optimization, content creation, technical SEO, and strategic
                    link building, ensuring your site meets search engine
                    requirements and delivers seamless user experience.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    Our SEO service platform provides a free trial service for
                    getting minimum searches and the other is Paid Subscription
                    based plans (Monthly, Quarterly, and Annual plans) for using
                    our platform for keyword researching. In free trail service
                    you find limited keywords researching rather than a paid
                    subscriptions. In our paid subscriptions the consumer gets
                    the best results according to your niches, find related
                    keywords by comparing another competitor’s database with
                    fetch automatically.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    Our objective is simple: drive high-quality organic traffic
                    to your website, increase brand visibility, and convert
                    visitors into customers. Whether you're looking to dominate
                    local search or compete globally, we create strategies
                    tailored to your unique goals.
                  </p>
                </section>
                <section className="mb-4">
                  <h5> SUBSCRIPTIONS:</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    Our SEO website offers flexible subscription and paid plans
                    tailored to meet different business needs. The Plans
                    provides essential SEO services, including a basic audit,
                    keyword research, and on-page optimization that’s includes
                    comprehensive SEO audits, targeted keyword research, content
                    creation, and backlink building. For businesses seeking more
                    robust services, the other service is offers in-depth
                    audits, local SEO, and advanced technical optimization. We
                    also provide a Custom Enterprise Plan with personalized
                    services for larger businesses. All plans come with monthly
                    reporting and performance tracking. The Paid Subscription
                    based plans (Monthly, Quarterly, and Annual plans). In our
                    paid subscriptions plans the consumer get best results
                    according to our niches find related keywords by comparing
                    another competitor’s database with fetch automatically.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    Some parts of the Service are billed on a subscription basis
                    ("Subscription(s)"). You will be billed in advance on a
                    recurring and periodic basis ("Billing process"). Billing
                    process are set either on a monthly or annual basis,
                    depending on the type of subscription plan you select when
                    purchasing a Subscription.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    At the end of each Billing process, your Subscription will
                    automatically renew under the exact same conditions unless
                    you cancel it or SeoBix cancels it. You may cancel your
                    Subscription renewal either through your online account
                    management page or by contacting SeoBix customer support
                    team through E-mail.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    A valid payment method, including credit card, Debit card,
                    Net banking, all UPI or PayPal, is required to process the
                    payment for your Subscription. You should provide SeoBix
                    with accurate and complete billing information including
                    full name, address, state, zip code, telephone number, and
                    valid payment method information. By submitting such payment
                    information, you automatically authorize SeoBix to charge
                    all Subscription fees incurred through your account to any
                    such payment instruments.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    Should automatic billing fail to occur for any reason,
                    SeoBix will issue an electronic invoice indicating that you
                    must proceed manually, within a certain deadline date, with
                    the full payment corresponding to the billing period as
                    indicated on the invoice.
                  </p>
                </section>{" "}
                <section className="mb-4">
                  <h5> AUTOMATIC RENEWAL:</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    Unless canceled before the end of the current subscription
                    period, your subscription will automatically renew. By
                    subscribing, you authorize SeoBix to charge the applicable
                    renewal fees to your designated payment method. You can
                    cancel your subscription anytime through your account
                    dashboard.
                  </p>
                </section>
                <section className="mb-4">
                  <h5> DISCOUNT POLICY:</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    We provide discounts and offers from time to time, you will
                    be notified once we come up with any offers, apart from that
                    all our prices are clearly mentioned on our website, and any
                    changes to it would be informed prior to you.
                  </p>
                </section>
                <section className="mb-4">
                  <h5> FREE TRIAL:</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    Try our SEO services with a Free Trial on our website! Get a
                    taste of the value we offer with a no-cost, no-obligation
                    trial that includes essential SEO services. During your
                    trial, we will perform a basic SEO audit, provide limited
                    keywords research, and optimize a few pages of your website.
                    This is a great opportunity to experience how our tools and
                    expertise can enhance your site's search engine ranking.
                    After the trial, you can choose from our subscription plans
                    to continue benefiting from our full range of SEO services.
                    Start your free trial today and boost your website’s SEO.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    At any time and without notice, SeoBix reserves the right to
                    (i) modify the terms and conditions of the Free Trial offer,
                    or (ii) cancel such Free Trial offer.
                  </p>
                </section>
                <section className="mb-4">
                  <h5> REFUNDS::</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    Except when required by law, paid Subscription fees are
                    non-refundable.
                  </p>
                </section>
                <section className="mb-4">
                  <h5> ACCOUNT CREATION:</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    When you create an account with us, you guarantee that you
                    are above the age of 18, and that the information you
                    provide us is accurate, complete, and current at all times.
                    Inaccurate, incomplete, or obsolete information may result
                    in the immediate termination of your account on the Service.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    You are responsible for maintaining the confidentiality of
                    your account and password, including but not limited to the
                    restriction of access to your computer and/or account. You
                    agree to accept responsibility for any and all activities or
                    actions that occur under your account and/or password,
                    whether your password is with our Service or a third-party
                    service. You must notify us immediately upon becoming aware
                    of any breach of security or unauthorized use of your
                    account.
                  </p>
                </section>
                <section className="mb-4">
                  <h5> INTELLECTUAL PROPERTY COPYRIGHT POLICY:</h5>

                  <p style={{ fontSize: ".9rem" }}>
                    If you are a copyright owner, or authorized on behalf of
                    one, and you believe that the copyrighted work has been
                    copied in a way that constitutes copyright infringement,
                    please submit your claim via email to information (
                    <a
                      href="https://www.SeoBix.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.SeoBix.com
                    </a>
                    ) with the subject line: "Copyright Infringement" and
                    include in your claim a detailed description of the alleged
                    Infringement as detailed below, under "DMCA Notice and
                    Procedure for Copyright Infringement Claims" You may be held
                    accountable for damages (including costs and attorneys'
                    fees) for misrepresentation or bad-faith claims on the
                    infringement of any Content found on and/or through the
                    Service on your copyright.
                  </p>
                </section>
                <section className="mb-4">
                  <h5> INTELLECTUAL PROPERTY RIGHTS:</h5>

                  <p style={{ fontSize: ".9rem" }}>
                    The Service and its original content, features and
                    functionality are and will remain the exclusive property
                    rights of SeoBix and its licensors. The Service is protected
                    by copyright, trademark, and other laws of both the United
                    States and foreign countries. Our trademarks and trade dress
                    may not be used in connection with any product or service
                    without the prior written consent of SeoBix.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    We are committed to upholding and protecting intellectual
                    property rights in all forms, including but not limited to
                    copyrights, trademarks, patents, trade secrets, and other
                    proprietary information.
                  </p>
                  <ul>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Respect for IP:</strong> We ensure that all
                      content, products, and services adhere to applicable
                      intellectual property laws and respect the rights of
                      creators, innovators, and businesses.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Prohibition of Infringement:</strong> Any
                      unauthorized use, reproduction, distribution, or
                      modification of intellectual property belonging to others
                      is strictly prohibited.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Safeguarding Our IP:</strong> We actively monitor,
                      enforce, and safeguard our intellectual property assets
                      through appropriate legal measures and technological
                      protections.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Collaboration and Licensing:</strong> When
                      engaging in partnerships, we establish clear agreements to
                      define ownership, licensing, and usage rights to ensure
                      mutual respect for IP.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Reporting Violations:</strong> We encourage
                      stakeholders to report any suspected IP infringement
                      promptly, and we commit to investigating and addressing
                      such matters in accordance with the law.
                    </li>
                  </ul>
                </section>
                <section className="mb-4">
                  <h5> TERMINATION:</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    We may terminate or suspend your account and bar access to
                    the Service immediately, without prior notice or liability,
                    under our sole discretion, for any reason whatsoever and
                    without limitation, including but not limited to a breach of
                    the Terms.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    If you wish to terminate your account, you may simply
                    discontinue using the Service. All provisions of the Terms
                    which by their nature should survive termination shall
                    survive termination, including, without limitation,
                    ownership provisions, warranty disclaimers, indemnity and
                    limitations of liability.
                  </p>
                </section>
                <section className="mb-4">
                  <h5> INDEMNIFICATION:</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    You agree to defend, indemnify and hold harmless SeoBix
                    platform and its licensee and licensors, and their
                    employees, contractors, agents, officers and directors, from
                    and against any and all claims, damages, obligations,
                    losses, liabilities, costs or debt, and expenses (including
                    but not limited to attorney's fees), resulting from or
                    arising out of a) your use and access of the Service, by you
                    or any person using your account and password, or b) a
                    breach of these Terms.
                  </p>
                </section>
                <section className="mb-4">
                  <h5>
                    {" "}
                    LIMITATION OF LIABILITY AND EXCLUSION OF CONSEQUENTIAL
                    DAMAGES:
                  </h5>
                  <p style={{ fontSize: ".9rem" }}>
                    In no event shall SeoBix, nor its directors, employees,
                    partners, agents, suppliers, or affiliates, be liable for
                    any indirect, incidental, special, consequential or punitive
                    damages, including without limitation, loss of profits,
                    data, use, goodwill, or other intangible losses, resulting
                    from (i) your access to or use of or inability to access or
                    use the Service; (ii) any conduct or content of any third
                    party on the Service; (iii) any content obtained from the
                    Service; and (iv) unauthorized access, use or alteration of
                    your transmissions or content, whether based on warranty,
                    contract, tort (including negligence) or any other legal
                    theory, whether or not we have been informed of the
                    possibility of such damage, and even if a remedy set forth
                    herein is found to have failed of its essential purpose.
                  </p>
                </section>
                <section className="mb-4">
                  <h5> COOKIES:</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    Cookies are small files stored on your computer by websites
                    to track user activity. SeoBix uses cookies to:
                  </p>
                  <ul style={{ fontSize: ".9rem" }}>
                    <li style={{ fontSize: ".9rem" }}>
                      Identify and track visitors.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      Understand website usage and preferences.
                    </li>
                  </ul>
                  <p style={{ fontSize: ".9rem" }}>
                    Visitors who prefer not to have cookies stored can adjust
                    their browser settings. However, some website features may
                    not function properly without cookies.
                  </p>
                </section>
                <section className="mb-4">
                  <h5> CONTACT US:</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    If you have any questions about these Terms, please contact
                    us at support@seobix.com .
                  </p>
                </section>
              </div>
            </div>

            <div className="col-md-1"></div>
          </div>
        </div>
      </div>
      {/* end */}
      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Termscondition;
